/* /tw/lang.js */
export default {
  // Home
  __dashboard: '儀錶板',
  __language: '語言',
  __languageTw: '繁體中文',
  __languageEn: 'English',
  __logout: '登出',
  __login: '登入',
  __account: '帳號',
  __password: '密碼',
  __rememberMe: '記住我',
  __forgotPassword: '忘記密碼?',
  __forgotPasswordDesc: '在下面輸入您的電子郵件地址，我們將發送重置密碼的連結給您',
  __sendResetLink: '發送重置連結',
  __goToSignIn: '返回 ',
  __signIn: '登入',
  __isError: '帳號密碼輸入錯誤 !',
  __success: '成功',
  __loginSuccess: '登入成功',
  __error: '錯誤',
  __otpResentSuccess: '驗證碼已重新發送',
  __otpResentFail: '重新發送失敗',
  __networkError: '網路錯誤，請稍後再試',
  // Reset Password
  __resetPassword: '重設密碼',
  __resetPasswordDesc: '為了安全起見，請在首次登入時更新您的密碼。',
  __newPassword: '新密碼',
  __confirmPassword: '再次輸入新密碼',
  __passwordHint: '密碼必須包含字母和數字',
  __passUpper: '至少包含一個大寫字母',
  __passLower: '至少包含一個小寫字母',
  __passNumber: '至少包含一個數字',
  __passLength: '密碼長度介於 12 - 20 個字元',
  __passNotMatch: '* 錯誤：密碼不符',
  // Job Assignment
  __jobAssignmentList: '工作指派',
  __jobAssignment: '工作指派',
  __newReport: '新增工作指派',
  __no: '流水號',
  __caseId: '案件號',
  __customer: '客戶名稱',
  __groupRemark: '群組',
  __item: '設備名稱',
  __reporter: '建立者',
  __editor: '編輯者',
  __createTime: '創建時間',
  __updateTime: '更新時間',
  __date: '日期',
  __closeDate: '結案日期',
  __duration: '歷時天數',
  __seName: '工程師',
  __assigned: '被指派者',
  __jobStatus: '案件狀態',
  __itemId: '設備型號',
  __place: '設備位置',
  __issue: '客戶反饋的問題',
  __remark: '問題註記',
  __remarks: '備註',
  __picVideo: '影片或圖片附件',
  __memberNotification: '通知群組成員',
  __feFeedbackReport: 'FE 回覆',
  __suggestion: '建議',
  __files: '檔案',
  __finishBtn: '完成',
  __selectFilesPlaceholder: '選擇檔案 (.jpg, .mp4)',
  __selectFilesPlaceholder2: '選擇(.jpg, .mp4)',
  __chooseFile: '選擇檔案',
  // History Record
  __historyRecordList: '歷史紀錄',
  __historyRecord: '歷史紀錄',
  __closeTime: '結案時間',
  // Warranty & Maintenance
  __warrantyAndMaintenance: '保固與維護',
  __serialNumber: '序號',
  __group: '群組',
  __contractNumber: '合約編號',
  __contractCurrency: '合約幣別',
  __startDate: '起始日期',
  __endDate: '結束日期',
  __status: '狀態',
  __contactSales: '聯絡業務',
  __maintenanceTab: '維護合約',
  __deviceTab: '設備',
  __maintenanceExpired30: '{days} 天內即將到期的維護合約',
  __maintenanceExpired: '已到期的維護合約',
  __deviceExpired30: '{days} 天內即將到期的設備',
  __deviceExpired: '已到期的設備',
  __newDevice: '新增設備',
  __newMaintenance: '新增維護合約',
  __type: '類型',
  __rental: '租賃',
  __sold: '出售',
  __contactStatus: '合約狀態',
  __projectId: '專案序號',
  // Configuration
  __Configuration: '設定',
  __Organization: '組織',
  __newOrganization: '新增組織',
  __Staff: '員工',
  __newStaff: '新增員工',
  __Customer: '客戶',
  __customerName: '客戶名稱',
  __newCustomer: '新增客戶',
  __Config: '設定',
  __Authority: '權限',
  __SystemFunctions: '系統功能',
  __View: '檢視',
  __Edit: '編輯',

  __groupName: '群組名稱',
  __vatNumber: '增值稅號',
  __orgNation: '國家',
  __nation: '國籍',
  __address: '地址',
  __tel: '電話',
  __staffName: '姓名',
  __email: '電子信箱',
  __codeType: '代碼類型',
  __codeValue: '代碼值',
  __codeText: '代碼文字',
  __order: '排序',
  __trackStatus: '追蹤狀態',
  __maintenanceReason: '送修原因',
  __managerMail: '主管信箱',
  __expiryReminder: '到期提醒',
  __newItem: '新增項目',
  __editItem: '編輯項目',
  __color: '色碼',
  __description: '說明',
  __englishText: '送修原因英文',
  __chineseText: '送修原因中文',
  __managerName: '主管姓名',
  __expirationReminderType: '到期提醒類型',
  __advanceReminderDays: '提前提醒天數',
  __notificationCenter: '通知中心',
  __editProfile: '編輯個人資料',
  __profile: '基本資料',
  __company: '公司',
  __division: '部門',
  __mobile: '手機',
  __oldPassword: '舊密碼',
  __cancel: '取消',
  __confirm: '確認',
  __pleaseInputOldPassword: '請輸入舊密碼',
  __pleaseConfirmPassword: '請再次輸入新密碼',
  __empId: '員工編號',
  __title: '職稱',
  __phone: '電話',
  __contactPerson: '聯絡人',
  __role: '角色',
  __manager: '主管',
  __staffRole: '工程師',
  __sales: '業務',
  __enabled: '啟用',
  __disabled: '停用',
  __detail: '詳細資料',

  // universal
  __languageSetting: '語系選擇',
  __select: '請選擇',
  __enter: '請輸入',
  __selectFile: '選擇檔案',
  __downloadExcel: '資料匯出',
  __inputError: '輸入錯誤',
  __inputErrorContent: '開始日期不得大於結束日期。',
  __inputErrorContent2: '兌換時間不得大於使用時間。',
  __completeInformation: '完整資料',
  __content: '內容',
  __back: '返回',
  __collapse: '收合',
  __save: '儲存',
  __new: '新增',
  __delete: '刪除',
  __deleteBtn: '刪除',
  __settings: '設定',
  __keywordSearch: '關鍵字查詢',
  __categorySearch: '依據類別查詢',
  __edit: '編輯',
  __total: '共',
  __all: '全部',
  __total2: '筆',
  __totalCount: '共 {count} 筆資料',
  __go: '前往第',
  __page: '頁',
  __savedSuccessfully: '儲存成功',
  __savedError: '儲存失敗',
  __noticeTitle: '提示',
  __noticeContent: '此通知僅供查閱。\n不會發送電子郵件或其他通知。',

  // ShowMsg
  __requiredTitle: '資訊不完整',
  __requiredContent: '請輸入所有必填',
  __newTitle: '已新增資料',
  __newContent: '系統已新增此筆資料',
  __revisedTitle: '已修改資料',
  __revisedContent: '系統已修改此筆資料',
  __deleteTitle: '已刪除資料',
  __deleteContent: '系統已刪除此筆資料',
  __importTitle: '已匯入',
  __importContent: '系統已將資料匯入!',
  __sendContent: '誠摯感謝您的詢問。',
  __imageTitle: '圖片不符合規定',
  __imageContent: '請確認圖片小於500KB，且圖片寬度1130像素，高度585像素。',
  __imageContent2: '請確認圖片小於500KB，且圖片寬度1200像素，高度800像素。',
  __imageSizeTitle: '圖片不符合規定',
  __imageSize500Content: '請確認圖片小於500KB。',
  __ckeditorTitle: '字數不符合規定',
  __ckeditorContent: '字數大於1500，請重新確認。',
  __ckeditorContent1: '字數大於20000，請重新確認。',
  __querySuccessTitle: '查詢成功',
  __querySuccessContent: '系統已查詢該訂單。',
  __maintenanceAnnouncementTitle: '公告期間',
  __maintenanceAnnouncementContent: '公告期間未輸入完成，請重新確認。',
  __maintenanceAnnouncementWrongTitle: '公告期間錯誤',
  __maintenanceAnnouncementWrongContent: '開始時間不能大於結束時間，請重新確認。',
  __batchBodificationTitle: '批次修改',
  __batchBodificationContent: '系統已批次修改資料!',
  __systemHint: '系統提示',
  __pleaseSelectItem: '請選擇項目',
  __startDateGreater: '開始日期不可大於結束日期',
  __endDateLess: '結束日期不可早於開始日期',
  __passwordNotMatch: "兩次輸入的密碼不一致",
  __invalidId: '無效或缺失的 ID',
  __noPermission: '您沒有存取此資料的權限',

  // ShowConfirm
  __confirmTitle2: '確定刪除',
  __confirmContent2: '您確定要刪除此筆資料嗎 ?',
  __confirmTitle10: '批次變更狀態',
  __confirmContent10: '您確定要將發送時間改為「今天」且使用狀態改為「已發送」 ?',

  // ConfirmPassword
  __deletePassword: '刪除密碼',
  __deletePasswordTitle: '請在下方輸入刪除密碼：',
  __deletePasswordError: '請輸入錯誤',
  __deletePasswordConfirm: '確認刪除',

  // ImportFile
  __import: '匯入',
  __importHint: '請確認上傳檔案符合 Excel 格式規範，點擊「下載範例」查看範本。',
  __downloadSample: '下載範例',
  __confirmImport: '確認匯入',
  __noFileSelected: '未選擇檔案',
  __pleaseSelectFile: '請先選擇檔案',
  __importFailed: '匯入失敗',
  __selectImportFile: '選擇要匯入的資料 (.xlsx)',

  __downloadPreview: 'PDF預覽',
  __downloadBtn: '下載',
  __download: '下載原始圖片',
  __contractAmount: '合約金額',
  __servicePlan: '服務方案',
  __preventiveMaintenance: '預防保養',
  __correctiveMaintenance: '故障修復',
  __inspection: '例行檢查',
  __installation: '安裝',
  __loadTest: '負載測試',
  __others: '其他',
  __servicePlanRemark: '服務方案備註',
  __contractServiceDescription: '合約服務說明',
  __sapInvoiceNumber: 'SAP發票號碼',
  __contractDocument: '合約文件',
  __devices: '設備',
  __fileName: '檔案名稱',
  __uploadDate: '上傳日期',
  __addAttachment: '新增附件',
  __maintenance: '維護合約',
  __contactPhone: '聯絡人電話',
  __contactEmail: '聯絡人信箱',
  __device: '設備',
  __brand: '品牌',
  __version: '版本',
  __itemCode: '項目代碼',
  __itemName: '項目名稱',
  __deviceCurrency: '設備幣別',
  __deviceAmount: '設備金額',
  __clientAssetNumber: '客戶資產編號',
  __deviceLocation: '設備位置',
  __deviceDescription: '設備描述',
  __project: '專案名稱',
  __projectID: '專案 ID',
  __bindMaintenanceContract: '綁定維護合約',
  __bindEquipment: '綁定設備',
  __maintenanceRecord: '維修紀錄',
  __exportExcel: '匯出 Excel',
  __importExcel: '匯入 Excel',
  __importResultTitle: '匯入結果',
  __importErrors: '錯誤詳情',

  // S3 File Manager
  __s3Files: '附件檔案',
  __s3Upload: '上傳檔案',
  __s3NoFiles: '尚未上傳任何檔案',
  __s3Delete: '刪除',
  __s3Rename: '重新命名',
  __s3Preview: '預覽 / 下載',
  __s3RenameDialog: '重新命名檔案',
  __s3NewFileName: '新檔案名稱',
  __s3Uploading: '上傳中...',
  __s3DeleteConfirm: '確定要刪除此檔案嗎？',
  __s3DeleteBindConfirm: '確定要刪除此綁定嗎？',
  __s3PreviewUrl: '臨時授權網址 (連結將於 1 小時後過期)',
  __s3UploadSuccess: '檔案上傳成功',
  __s3DeleteSuccess: '檔案刪除成功',
  __deleteSuccess: '刪除成功',
  __s3RenameSuccess: '檔案重新命名成功',
  __s3UrlCopied: 'URL 已複製到剪貼簿',
  __s3NewFolder: '新增資料夾',
  __s3FolderName: '資料夾名稱',
  __s3FolderCreated: '資料夾建立成功',
  __s3GoBack: '.. 返回上層',

  // Dashboard
  __dashboardJobAssignment: '工作指派',
  __dashboardIncompleteTasks: '未完成任務數量',
  __dashboardNoData: '暫無資料',
  __dashboardViewMore: '查看更多',
  __dashboardEngineerAvgLoad: '工程師平均案件量',
  __dashboardMaintenanceExpiry: '維護合約到期',
  __dashboardMaintenanceExpiringDays: '{days} 天內即將到期的維護合約',
  __dashboardMaintenanceExpired: '已到期的維護合約',
  __dashboardDeviceWarrantyExpiry: '設備保固到期',
  __dashboardDeviceExpiringDays: '{days} 天內即將到期的設備',
  __dashboardDeviceExpired: '已到期的設備',
  __dashboardAvg: '平均',

  // JobAssignmentList - Supervisor Stats Table
  __today: '今天',
  __efficient: '平均處理天數(每案件)',
  __urgent: '緊急',
  __unfinishedTask: '未完成任務',
  __closed: '已結案',
  __currentlySelected: '目前已選擇',

  // Notification Center labels
  __notifJobAssignment: '工作指派',
  __notifMaintenanceExpiry: '維護到期',
  __notifDeviceExpiry: '設備到期',

  // JobAssignment page
  __sectionReport: '報告資訊',
  __sectionAssign: '指派資訊',
  __sectionHistory: '歷史紀錄',
  __underWarranty: '保固中',
  __noFilesSelected: '尚未選擇檔案',
  __noHistoryRecords: '無歷史紀錄',
  __noEmployeesFound: '未找到員工',
  __clickCopy: '點擊複製',
  __selected: '已選擇',
  __none: '無',
  __noAttachments: '無附件',
  __functionMenu: '功能選單',
  __renew: '續約',
  __renewSuccessMsg: '已在畫面上展延起訖時間，確認資料無誤後點擊「確認」即可保存為新的維護合約。',
  __systemError: '系統錯誤：請聯繫系統管理人員。(編號：{code})',
  __getDataError: '系統錯誤：無法取得資料',
  __queryFailed: '查詢失敗',
  __exportPdfError: 'PDF 匯出失敗，請聯繫系統管理人員',
  __exportFailed: '匯出失敗',
  __deleteFailed: '刪除失敗',
  __uploadFailed: '上傳失敗',
  __uploadFailedPartially: '部分檔案上傳失敗，請重試',
  __saveFailed: '儲存失敗',
  __accountExists: '帳號已存在',
  __groupNameExists: '組織名稱已存在',
  __customerNameExists: '客戶名稱已存在',
  __serialNumberExists: '序號已存在',
  __invalidEmail: '電子郵件格式不正確',
  __duplicateTrackStatus: '此追蹤狀態已存在，請輸入其他名稱。',
  __duplicateEnglishText: '此英文名稱已存在，請輸入其他名稱。',
  __duplicateChineseText: '此中文名稱已存在，請輸入其他名稱。',
  __hasPendingCases: '該帳戶尚有未完成的工作指派，無法刪除。',
  __keywordSearchTooltip: '支援模糊查詢欄位：\n- 流水號\n- 案件號\n- 客戶名稱\n- 項目\n- 建立者\n- 當前指派者\n- 狀態',
  __keywordSearchMaintenanceTooltip: '支援模糊查詢欄位：\n- 流水號\n- 序號\n- 客戶名稱\n- 群組\n- 合約編號\n- 合約幣別\n- 狀態',
  __keywordSearchDeviceTooltip: '支援模糊查詢欄位：\n- 流水號\n- 類型\n- 序號\n- 客戶名稱\n- 群組\n- 專案ID\n- 專案名稱\n- 合約狀態\n- SAP發票號碼\n- 項目名稱\n- 項目代碼',
  __noDevicesAdded: '尚未添加設備',
  __noMaintenanceRecordsAdded: '尚未添加維護合約',
  __copyWeb: '複製',
  __openWeb: '開啟',
  __copy: '複製連結',
  __open: '以分頁開啟',
}